// =============================================================================
// Server-safe constants of the intro preloader (no "use client": the layout
// inlines the script in the <head>, which must stay free of client modules)
// =============================================================================

/** sessionStorage key set once the preloader has played in this session */
export const PRELOADER_STORAGE_KEY = "preloader-done";

/**
 * Pages opened straight away, often from another site (the privacy policy
 * and the terms, linked from the Google consent screen): no intro there.
 */
const NO_INTRO_PATHS = String.raw`^/(en/)?(privacy|terms)/?$`;

/**
 * Robots (search engines, Google's verification of the OAuth app…) read the
 * page at once: the curtain of the intro would hide it. Lighthouse is not
 * one of them, it measures what visitors get.
 */
const ROBOTS = String.raw`bot|crawl|spider|slurp|google`;

/**
 * Inline script run before the first paint: skips the preloader for the rest
 * of the session, for visitors who prefer reduced motion, on the legal pages
 * and for robots.
 */
export const PRELOADER_SCRIPT = `(function(){try{var d=document.documentElement;if(sessionStorage.getItem("${PRELOADER_STORAGE_KEY}")||matchMedia("(prefers-reduced-motion: reduce)").matches||new RegExp("${NO_INTRO_PATHS}").test(location.pathname)||new RegExp("${ROBOTS}","i").test(navigator.userAgent)){d.dataset.preloader="skip"}}catch(e){document.documentElement.dataset.preloader="skip"}})();`;

// =============================================================================
